module.exports = __webpack_public_path__ + "Roboto-Light.46e48ce0628835f68a73.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Light.ttf
// module id = ../../../../../src/font/roboto/Roboto-Light.ttf
// module chunks = 1